import { render, staticRenderFns } from "./TenancySubscriptionSinglePlanCard.vue?vue&type=template&id=ac5b76dc&scoped=true&"
import script from "./TenancySubscriptionSinglePlanCard.vue?vue&type=script&lang=js&"
export * from "./TenancySubscriptionSinglePlanCard.vue?vue&type=script&lang=js&"
import style0 from "./TenancySubscriptionSinglePlanCard.vue?vue&type=style&index=0&id=ac5b76dc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac5b76dc",
  null
  
)

export default component.exports